import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  indexedDBLocalPersistence, 
  browserLocalPersistence, 
  initializeAuth 
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 
import { getAnalytics, isSupported } from "firebase/analytics"; 
import { Capacitor } from "@capacitor/core";

const firebaseConfig = {
  apiKey: "AIzaSyD8XYGjudHOuNgYtFzFiEes1xLV-5iWX0E",
  authDomain: "abc.avaami.com",
  projectId: "avaami-odoo",
  storageBucket: "avaami-odoo.firebasestorage.app",
  messagingSenderId: "663892689266",
  appId: "1:663892689266:web:7138ca0d47d2b5ee6c5deb",
  measurementId: "G-P495H3RFPY"
};

// 1. Initialize Firebase App
const app = initializeApp(firebaseConfig);

// 2. Initialize Auth with cross-platform persistence support
export const auth = initializeAuth(app, {
  persistence: Capacitor.isNativePlatform() 
    ? [indexedDBLocalPersistence, browserLocalPersistence]
    : browserLocalPersistence
});

// 3. Initialize Analytics conditionally
isSupported().then((supported) => {
  if (supported) {
    getAnalytics(app);
  }
});

// 4. Initialize Firestore and Storage
export const db = getFirestore(app);
export const storage = getStorage(app); 

// 5. Configure Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;